<template>
  <div class="no-ime">
    <div class="no-ime__proxy_container">
      <input :disabled="disable" ref="txtProxy" type="password" class="no-ime__proxy" v-on="$listeners" autocomplete="off"
        @focus="onTxtProxyFocus()" @mousedown="selectDelay(100)" @mouseup="selectDelay(100)" @blur="onTxtProxyBlur()" @keydown="syncSelectedDelay()"/>
    </div>
    <span ref="divView" :class="viewClass">{{viewText}}</span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      value: '',
      selected: false,
      focused: false
    }
  },
  props: {
    placeholder: String,
    upperCase: Boolean,
    disable: Boolean,
    inputNum: Number
  },
  computed: {
    viewClass () {
      return {
        'no-ime__view': true,
        'no-ime__view__selected': this.selected,
        'no-ime__view__focused': Boolean(this.focused && this.value),
        'no-ime__view__focused__empty': Boolean(this.focused && !this.value)
      }
    },
    viewText () {
      return this.value || this.placeholder
    }
  },
  mounted () {
    this.$refs.txtProxy.value = this.value
    const onInputDelay = _.throttle(() => {
      let value = this.$refs.txtProxy.value.replace('=', '') ?? ''
      value = value.replace('<', '') ?? ''
      if (this.inputNum && value.length > this.inputNum) {
        return
      }
      if (this.upperCase) {
        const upperValue = value.toUpperCase()
        if (value !== upperValue) {
          value = upperValue
        }
      }
      if (this.value === value) return
      this.value = value
    }, 200)
    this.$refs.txtProxy.oninput = onInputDelay
  },
  beforeDestroy () {
    if (this.$refs.txtProxy) {
      this.$refs.txtProxy.oninput = null
    }
  },
  methods: {
    onTxtProxyFocus () {
      this.focused = true
      this.select()
    },
    onTxtProxyBlur () {
      this.focused = false
      this.syncSelectedDelay()
    },
    getValue () {
      let codeValue = this.$refs.txtProxy.value.replace('=', '').replace('<', '')
      // 如果有规定长度,并且值的长度比规定的要长,那么把值截取到规定的长度
      if (this.inputNum && codeValue.length > this.inputNum) {
        codeValue = codeValue.substring(0, this.inputNum)
      }
      this.$refs.txtProxy.value = codeValue
      return this.$refs.txtProxy ? (this.upperCase ? this.$refs.txtProxy.value.toUpperCase() : this.$refs.txtProxy.value) : this.value
    },
    setValue (val) {
      if (val === null || val === undefined) {
        val = ''
      }
      if (this.upperCase) {
        val = val.toUpperCase()
      }
      this.value = val
      if (this.$refs.txtProxy) {
        this.$refs.txtProxy.value = val
      }
    },
    syncSelectedDelay (duration) {
      setTimeout(() => {
        this.syncSelected()
      }, duration ?? 0)
      this.$emit('value', this.value)
    },
    syncSelected () {
      const txtProxy = this.$refs.txtProxy
      const selected = Boolean(this.getValue()) && txtProxy === document.activeElement && txtProxy.selectionEnd > txtProxy.selectionStart
      if (this.selected !== selected) {
        this.selected = selected
      }
    },
    focus () {
      this.$refs.txtProxy && this.$refs.txtProxy.focus()
    },
    selectDelay (duration) {
      setTimeout(() => {
        this.select()
      }, duration ?? 0)
    },
    select () {
      this.$refs.txtProxy && this.$refs.txtProxy.select()
      this.selected = !!this.getValue()
    }
  }
}

</script>

<style lang="scss">
@keyframes caret-blink {
  0% {
    border-right: black 1px solid;
  }
  50% {
    border-right: black 1px solid;
  }
  50.01% {
    border-right: transparent 1px solid;
  }
  100% {
    border-right: transparent 1px solid;
  }
}

@keyframes caret-blink-empty {
  0% {
    border-left: black 1px solid;
  }
  50% {
    border-left: black 1px solid;
  }
  50.01% {
    border-left: transparent 1px solid;
  }
  100% {
    border-left: transparent 1px solid;
  }
}

.no-ime {
  position: relative;
  min-height: 40px;
  // display: inline-block;
  display: flex;
  align-items: center;
  // input {
  //   // normalize font width
  //   font-size: 14px; font-family: Source Code Pro,Consolas,Monaco,Courier New;
  // }
  &__view {
    margin: 0 4px;
    // border-right: black 1px solid;
  }
  &__view__selected {
    // background-color: #3390FF;
    color: white;
  }
  &__view__focused {
    animation: caret-blink 1s linear infinite;
  }
  &__view__focused__empty {
    animation: caret-blink-empty 1s linear infinite;
  }
  &__proxy_container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  &__proxy {
    width: 100%;
    color: transparent;
    background: transparent;
    caret-color: transparent;
  }
  &__proxy[type=password] {
    font-size: 1.3em;
  }
  &__proxy::selection {
    color: transparent;
    background: transparent;
  }
}
.no-ime__proxy_container {
  input {
    border: none;
    outline: none;
    background: transparent;
  }
  input:focus {
    border: none;
    outline: none;
  }
}
.no-ime__view {
  display:inline-block;
  width: 100%;
  text-align:left;
  border-bottom:1px solid #aaa;
  font-size:24px;
  color:#666
}

</style>
